import React from "react";

const ShapeMobile3 = () => {
	return (
		<svg width={375} height={564} viewBox="0 0 375 564" fill="none">
			<g filter="url(#filter0_f_420_50)">
				<path
					d="M184.441 413.512C267.471 413.364 334.659 345.934 334.511 262.904C334.363 179.874 266.935 112.685 183.904 112.834C100.874 112.982 33.685 180.411 33.8332 263.441C33.9813 346.471 101.411 413.66 184.441 413.512Z"
					fill="url(#paint0_radial_420_50)"
					fillOpacity="0.5"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_420_50"
					x="-116.167"
					y="-37.1666"
					width="600.679"
					height="600.679"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={75}
						result="effect1_foregroundBlur_420_50"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_420_50"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(525.481 312.902) rotate(-178.397) scale(694.786 630.914)"
				>
					<stop offset="0.277446" stopColor="#00EBFF" />
					<stop offset="0.71875" stopColor="#FF39B0" />
					<stop offset={1} stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default ShapeMobile3;
